import { useContext } from 'react';
import { ToastContext, type ToastApi, type ToastInput, type ToastTone } from './toast-context';

export type { ToastApi, ToastInput, ToastTone };

export function useToast(): ToastApi {
  const ctx = useContext(ToastContext);
  if (!ctx) {
    throw new Error('useToast must be used within ToastProvider');
  }
  return ctx;
}
